import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {TabPanel, TabView} from 'primereact/tabview'
import {useMemo, useRef} from 'react'
import {useParams} from 'react-router-dom'
import {ReactComponent as DuoClock} from '../../assets/icons/DuoClock.svg'
import TranslateUtils from '../../i18n/TranslateUtils'
import GenericLogTable from '../generic-log/GenericLogTable'
import StyledTitle from '../layout/StyledTitle'

const DeviceActivitiesLog = () => {
    useSignals()
    const {id: idString} = useParams()
    const id = useMemo(() => {
        if (!idString) {
            return null
        }
        return parseInt(idString)
    }, [idString])
    const {translateCommons} = TranslateUtils()
    const onWristLogRef = useRef(null)
    const batteryChargeRef = useRef(null)

    const activeIndex = useSignal(0)

    return (
        <div className="mb-3">
            <StyledTitle
                icon={<DuoClock />}
                colorClass="text-blue-600"
                title={translateCommons('Device Activities Log')}
            />
            {/* <Button
                className=" gap-1 "
                icon="pi pi-download"
                label={translateCommons('On-Wrist Logs')}
                onClick={() => {
                    if (!!id) {
                        onWristLogRef.current?.showForm({
                            refId: id,
                            type: 'onWristLog',
                        })
                    }
                }}
            />{' '}
            <Button
                className="  "
                icon="pi pi-download"
                label={translateCommons('Battery Charge Logs')}
                onClick={() => {
                    if (!!id) {
                        batteryChargeRef.current?.showForm({
                            refId: id,
                            type: 'batteryChargeLog',
                        })
                    }
                }}
            /> */}
            <TabView
                activeIndex={activeIndex.value}
                onTabChange={e => {
                    activeIndex.value = e.index
                }}>
                <TabPanel header={translateCommons('On-Wrist Logs')}>
                    <div
                        className={`col-12 m-0  p-0 flex gap-2   flex-column md:flex-row align-items-center justify-content-center md:justify-content-between`}>
                        <h5 className="m-0 text-base md:text-lg   text-700">
                            {translateCommons(
                                'The audit log shows various changes made when the patient is wearing the device. For example, it records when the patient puts on or takes off the device',
                            )}
                        </h5>
                        <div>
                            <Button
                                className="p-button-text bg-teal-50 gap-1 px-3 w-17rem"
                                icon="pi pi-download"
                                label={translateCommons('Show Log')}
                                onClick={() => {
                                    if (!!id) {
                                        onWristLogRef.current?.showForm({
                                            refId: id,
                                            type: 'onWristLog',
                                        })
                                    }
                                }}
                            />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={translateCommons('Battery Charge Logs')}>
                    <div
                        className={`col-12 m-0  p-0 flex gap-2 flex-column md:flex-row align-items-center justify-content-center md:justify-content-between`}>
                        <h5 className="m-0 text-base md:text-lg text-700">
                            {translateCommons(
                                'The audit log shows various changes made when the device is charging. For example, it records when the device is charging or not charging',
                            )}
                        </h5>
                        <Button
                            className="p-button-text  bg-teal-50 gap-1 px-3 w-17rem"
                            icon="pi pi-download"
                            label={translateCommons('Show Log')}
                            onClick={() => {
                                if (!!id) {
                                    batteryChargeRef.current?.showForm({
                                        refId: id,
                                        type: 'batteryChargeLog',
                                    })
                                }
                            }}
                        />
                    </div>
                </TabPanel>
            </TabView>
            <GenericLogTable ref={onWristLogRef} />
            <GenericLogTable ref={batteryChargeRef} />
        </div>
    )
}

export default DeviceActivitiesLog
